import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "../../../../components/Atomos/Modals/Modal";
import Button from "../../../../components/staff/Button";
import SaveChanges from "../../../../components/Atomos/Icons/EditMode/SaveChanges";
import SendEmail from "../../../../components/Atomos/Icons/Email";
import TrashIcon from "../../../../components/Atomos/Icons/EditMode/Trash";
import { useStaffMode } from "../../../../hooks/StaffModeProvider";
import { useEditParticipantForm } from "../hooks/useEditParticipantForm";
import { useEditParticipantSave } from "../hooks/useEditParticipantSave";
import {
  selectIsEditMode,
  selectIsRegistrationCancelled,
} from "../editParticipant.selectors";

export default function EditParticipantFooter (): React.ReactElement {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const { isStaffMode } = useStaffMode();
  const isEditMode = useSelector(selectIsEditMode);
  const isRegistrationCancelled = useSelector(selectIsRegistrationCancelled);
  const mode = isEditMode ? "edit" : "add";
  const { paymentFieldsDisabled } = useEditParticipantForm();
  const {
    isSaving,
    handleDelete,
    handleSaveRegistration,
    handleCancelRegistration,
    handleRestoreRegistration,
  } = useEditParticipantSave();

  return (
    <>
      <div className="flex flex-col md:flex-row justify-end gap-4 m-6">
        {mode === "edit" && (
          <div className="flex flex-1 flex-wrap gap-3">
            <Button
              text="Delete"
              onClick={() => setDeleteModalOpen(true)}
              color="primary"
              variant="filled"
              size="fixed"
              icon={<TrashIcon className="w-4 h-4" />}
              disabled={isSaving}
            />
            <Button
              text={
                isRegistrationCancelled
                  ? "Restore Registration"
                  : "Cancel Registration"
              }
              onClick={() => {
                if (isRegistrationCancelled) {
                  void handleRestoreRegistration();
                  return;
                }
                void handleCancelRegistration();
              }}
              color="neutral"
              variant="filled"
              size="fixed"
              disabled={isSaving}
            />
          </div>
        )}
        <Button
          text="Save"
          onClick={() => {
            void handleSaveRegistration(false);
          }}
          color="secondary"
          variant="outlined"
          size="fixed"
          icon={<SaveChanges />}
          disabled={paymentFieldsDisabled || isSaving}
        />
        <Button
          text="Save & Send Invoice"
          onClick={() => {
            void handleSaveRegistration(true);
          }}
          color="secondary"
          variant="filled"
          size="fixed"
          icon={<SendEmail className="w-4 h-4" />}
          disabled={paymentFieldsDisabled || isSaving}
        />
      </div>

      <Modal
        isModalOpen={deleteModalOpen}
        toggleModal={() => setDeleteModalOpen(false)}
        title="Delete"
        compact
        className="max-w-md"
      >
        <p className="text-gray-800">
          Are you sure you want to delete this item?
        </p>
        <div className="mt-6 flex flex-wrap justify-end gap-3">
          <Button
            text="Cancel"
            onClick={() => setDeleteModalOpen(false)}
            color="neutral"
            variant="outlined"
            size="fixed"
          />
          <Button
            text="Delete"
            onClick={() => {
              setDeleteModalOpen(false);
              void handleDelete();
            }}
            color={isStaffMode ? "secondary" : "primary"}
            variant="filled"
            size="fixed"
            disabled={isSaving}
          />
        </div>
      </Modal>
    </>
  );
}
